module.exports = "/_next/static/videos/laptop-white-30c3a83b062ab6d9e4fba152053145a6.mp4";